import {Component, inject, input, output, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {NouisliderComponent} from 'ng2-nouislider';
import {FormsModule} from '@angular/forms';


@Component({
  selector: 'app-rating-points-range',
  templateUrl: './rating-points-range.component.html',
  styleUrls: ['./rating-points-range.component.scss'],
  imports: [NouisliderComponent, FormsModule]
})
export class RatingPointsRangeComponent {
  platformId = inject(PLATFORM_ID);


  readonly min = input<number>();
  readonly max = input<number>();
  readonly range = input<number[]>();

  readonly rangeChange = output<number[]>();

  get config() {
    return {
      connect: true,
      start: this.range(),
      step: 1,
      tooltips: true,
      format: {
        from: (value: number) => Math.round(value),
        to: (value: number) => Math.round(value),
      },
      range: {
        min: this.min(),
        max: this.max()
      },
      pips: {
        mode: 'count',
        density: 5,
        values: 3,
        stepped: true
      }
    };
  }

  protected readonly isPlatformBrowser = isPlatformBrowser;

  public handleChange = (values: number[]) => {
    this.rangeChange.emit(values);
  };
}
